// import Swiper JS
import Swiper,  {Navigation, Pagination, Mousewheel, A11y, EffectFade, Keyboard, Autoplay, Lazy, Scrollbar} from 'swiper';

Swiper.use([Navigation, Pagination, Mousewheel, A11y, EffectFade, Keyboard, Autoplay, Lazy, Scrollbar ]);

// Styles imports | Hint: '.scss' at the end
import 'swiper/swiper.scss'; // core Swiper
import 'swiper/swiper-bundle.min.js'; 
import 'swiper/modules/navigation/navigation.scss'; // Navigation module
import 'swiper/modules/pagination/pagination.scss'; // Pagination module
import 'swiper/modules/effect-fade/effect-fade.scss'; // Effect-Fade module
import 'swiper/modules/autoplay/autoplay.scss'; // Autoplay module
import 'swiper/modules/a11y/a11y'; // Ally


const STRINGS = document.body.dataset.slider.split(',');

const defaultSwiperOptions = {
    a11y: true,
    keyboard: true,
    autoplay: false,
    a11y: {
        enabled: true,
        paginationBulletMessage: STRINGS[0],
        prevSlideMessage: STRINGS[1],
        nextSlideMessage: STRINGS[2]
    },
};

// Hint: Add to item slide/element the class: 'swiper-slide'

class SliderInit {
    constructor() {
        this.initSlider('.slider-box', 'swiper-slide-item', {
            loop: false,
            spaceBetween: 90
        });	

        this.initSlider('.page-slider', 'swiper-slide', {
            effect: "fade",
            autoplay: true,
            loop: true,
            speed: 1000,
        });	

        this.initSlider('.text-with-image-slider', 'text-with-image-item', {
            slidesPerView: 1,
        });	
    }

    initSlider(sliderSelector, slideClass, options) {
        const sliderEl = document.querySelector(sliderSelector);
        if (!sliderEl) return;
        const wrapper = sliderEl.querySelector('.swiper-wrapper');
        if (!wrapper) return;
        if (wrapper.querySelectorAll('.' + slideClass).length < 2) return;

        const swiper = new Swiper(sliderSelector, {
            ...defaultSwiperOptions,
            ...options,
            slideClass: slideClass,
            navigation: {
                nextEl: sliderSelector + " .swiper-button-next",
                prevEl: sliderSelector + " .swiper-button-prev",
            },
            pagination: {
                el: sliderSelector + " .swiper-pagination",
                clickable: true
            }
        });
    }
}

export default SliderInit;